import { ModuleWithProviders, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// Syncfusion
import { DatePickerModule } from '@syncfusion/ej2-angular-calendars';
import {
  ColumnChooserService, FilterService, GridModule, GroupService, PageService, ReorderService, SortService, GridAllModule, FreezeService, SelectionService,
} from '@syncfusion/ej2-angular-grids';
import { AccordionModule, SidebarModule } from '@syncfusion/ej2-angular-navigations';
import { UploaderModule } from '@syncfusion/ej2-angular-inputs';
import { DialogModule, TooltipModule } from '@syncfusion/ej2-angular-popups';
import { DropDownListModule, MultiSelectAllModule, AutoCompleteModule } from '@syncfusion/ej2-angular-dropdowns';

import { RadioButtonModule, CheckBoxModule } from '@syncfusion/ej2-angular-buttons';
import { InPlaceEditorModule } from '@syncfusion/ej2-angular-inplace-editor';
import {
  AccumulationChartModule,
  PieSeriesService, AccumulationLegendService, AccumulationTooltipService, AccumulationAnnotationService,
  AccumulationDataLabelService,
} from '@syncfusion/ej2-angular-charts';

// Global Custom Components
import {
  DeleteButtonComponent, VersionModalComponent, ErrorMessagesComponent, ErrorComponent, WarningIconComponent, EsigModalComponent, CompanyDetailsComponent,
  FeatureComponent
} from './components/index';
import { FileUploadComponent } from './components/common/file-upload/file-upload.component';
import { CustomSidebarComponent } from './components/common/custom-sidebar/custom-sidebar.component';
import { DateToLocalePipe } from './pipes/date-to-locale.pipe';
import { ESGSubmissionService } from './shared/services/esg-submission-service';
import { PragmaticGridColumnComponent } from './components/common/pragmatic-grid-column/pragmatic-grid-column.component';

@NgModule({
  declarations: [
    DeleteButtonComponent,
    VersionModalComponent,
    EsigModalComponent,
    ErrorMessagesComponent,
    ErrorComponent,
    FileUploadComponent,
    CustomSidebarComponent,
    DateToLocalePipe,
    WarningIconComponent,
    CompanyDetailsComponent,
    PragmaticGridColumnComponent,
    FeatureComponent,
  ],
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,

    CheckBoxModule,
    TooltipModule,
    RadioButtonModule,
    MultiSelectAllModule,
    AutoCompleteModule,
    UploaderModule, DialogModule,
    GridModule, DropDownListModule, GridAllModule,
    AccordionModule, DatePickerModule, SidebarModule, InPlaceEditorModule,
    AccumulationChartModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    CommonModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,

    DeleteButtonComponent,
    VersionModalComponent,
    EsigModalComponent,
    ErrorMessagesComponent,
    ErrorComponent,
    FileUploadComponent,
    CustomSidebarComponent,
    DateToLocalePipe,
    CheckBoxModule,
    TooltipModule,
    RadioButtonModule,
    MultiSelectAllModule,
    AutoCompleteModule,
    UploaderModule, DialogModule,
    GridModule, DropDownListModule, GridAllModule,
    AccordionModule, DatePickerModule, SidebarModule, InPlaceEditorModule,
    AccumulationChartModule,
    WarningIconComponent,
    CompanyDetailsComponent,
    PragmaticGridColumnComponent,
    FeatureComponent

  ],
})
export class RTSharedModule {
  static forRoot() : ModuleWithProviders<RTSharedModule> {
    return {
      ngModule: RTSharedModule,
      providers: [
        PageService, SortService, FilterService, GroupService, ColumnChooserService,
        ReorderService,
        FreezeService,
        SelectionService,
        PieSeriesService, AccumulationLegendService, AccumulationTooltipService, AccumulationDataLabelService, AccumulationAnnotationService,
        ESGSubmissionService
      ],
    };
  }
}
